import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default {
    bind: function(el, binding){

        el.tooltip = tippy(el,{
            dynamicTitle: true
        });

    },

    unbind: function(el){
        el.tooltip.destroyAll();
    }
}


// WEBPACK FOOTER //
// ./src/js/Directives/Tooltip.js